import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

import { TooltipComponent } from '@shared/tooltip/tooltip.component';

@Component({
    selector: 'app-page-range-format-error.',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        TooltipComponent,
    ],
    template: ` <p class="flex items-center">
        Invalid page range format.
        <app-tooltip>
            <mat-icon svgIcon="info" class="flex" trigger></mat-icon>
            <div content>
                <p class="flex items-center gap-5">
                    <mat-icon svgIcon="check" class="color-yellow-green8" />
                    Valid page range formats:
                </p>
                <ul class="ml-2">
                    <li>
                        Single pages separated by commas
                        <span class="text-bold">(i.e: 1, 2, 3)</span>
                    </li>
                    <li>
                        Ranges using start - end page
                        <span class="text-bold">(i.e: 1-3, 2-4)</span>
                    </li>
                    <li>
                        A combination of single pages and ranges
                        <span class="text-bold">(i.e: 1-3, 5, 7-9)</span>
                    </li>
                </ul>
                <p class="flex items-center gap-5">
                    <mat-icon svgIcon="close" class="color-status-red4" />
                    Invalid page range format
                </p>
                <ul class="ml-2">
                    <li>
                        Ranges with three or more numbers separated by dashes
                        <span class="text-bold">(i.e: 1-3-5)</span>
                    </li>
                </ul>
            </div>
        </app-tooltip>
    </p>`,
})
export class PageRangeFormatErrorComponent {}
